// Cart Stock Check Animation — permanent implementation of A/B test winner
(function () {
  const NS = 'cart-stock-check';

  const searchIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.33268 2.91675C5.34352 2.91675 2.91602 5.34425 2.91602 8.33341C2.91602 11.3226 5.34352 13.7501 8.33268 13.7501C11.3218 13.7501 13.7493 11.3226 13.7493 8.33341C13.7493 5.34425 11.3218 2.91675 8.33268 2.91675ZM8.33268 3.75008C10.8627 3.75008 12.916 5.80341 12.916 8.33341C12.916 10.8634 10.8627 12.9167 8.33268 12.9167C5.80268 12.9167 3.74935 10.8634 3.74935 8.33341C3.74935 5.80341 5.80268 3.75008 8.33268 3.75008Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9614 16.3719L12.1622 11.5735C11.9997 11.411 11.7355 11.411 11.573 11.5735C11.4105 11.736 11.4105 12.0002 11.573 12.1627L16.3714 16.9619C16.5347 17.1244 16.798 17.1244 16.9614 16.9619C17.1239 16.7985 17.1239 16.5352 16.9614 16.3719Z" fill="currentColor"/>
  </svg>`;

  const tickIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6029 10.6488H9.62501C9.58193 10.6489 9.53935 10.6398 9.50009 10.622C9.46084 10.6043 9.42583 10.5784 9.39741 10.546C9.369 10.5137 9.34783 10.4756 9.33532 10.4344C9.32282 10.3932 9.31927 10.3498 9.32492 10.3071C9.3472 10.0155 9.39751 9.68281 9.4519 9.32296C9.5394 8.7442 9.63783 8.09298 9.63783 7.49115C9.63783 6.47339 9.3352 5.57924 8.10042 5.46345C7.98289 7.09636 7.71919 8.2149 7.15222 9.12545C6.5753 10.0519 5.70189 10.7377 4.36633 11.5056L5.10976 16.6247C5.72258 16.9833 6.05838 17.2111 6.71489 17.3047C7.36527 17.3973 8.38386 17.397 10.4578 17.3963C12.3627 17.3956 7.95357 17.395 11.046 17.395C12.3913 17.395 12.1223 16.5633 11.8669 16.495C11.796 16.4761 11.7344 16.432 11.6936 16.3711C11.6528 16.3102 11.6355 16.2364 11.6451 16.1637C11.6546 16.091 11.6903 16.0243 11.7455 15.9759C11.8006 15.9275 11.8715 15.9009 11.9449 15.9009V15.9006C12.917 15.9006 13.0783 14.8122 12.4356 14.6179C12.1037 14.5175 12.1786 14.0258 12.523 14.0258C13.7916 14.0258 13.7554 12.7384 13.0155 12.6296C12.6869 12.5812 12.6562 12.0957 13.0199 12.031C13.1749 11.9988 13.3149 11.916 13.4178 11.7957C13.4856 11.7149 13.5337 11.6195 13.5584 11.517C13.19 11.2878 12.8662 10.9936 12.6029 10.6488ZM16.8803 7.17036C16.9373 7.11525 17.0138 7.08476 17.0931 7.08545C17.1725 7.08614 17.2484 7.11795 17.3045 7.17405C17.3606 7.23013 17.3924 7.30601 17.3931 7.38533C17.3938 7.46465 17.3633 7.54107 17.3082 7.59813L15.1018 9.80371C15.0451 9.86042 14.9681 9.89228 14.8879 9.89228C14.8076 9.89228 14.7307 9.86042 14.6739 9.80371L13.5707 8.70094C13.5421 8.67296 13.5193 8.63959 13.5037 8.60275C13.4881 8.56592 13.4799 8.52635 13.4797 8.48633C13.4795 8.44632 13.4872 8.40666 13.5024 8.36965C13.5176 8.33264 13.54 8.29902 13.5683 8.27072C13.5966 8.24243 13.6303 8.22003 13.6673 8.20482C13.7043 8.18961 13.744 8.1819 13.784 8.18212C13.824 8.18235 13.8636 8.19051 13.9005 8.20613C13.9373 8.22175 13.9707 8.24452 13.9987 8.27313L14.8879 9.16202L16.8803 7.17036Z" fill="currentColor"/>
  </svg>`;

  let animationTimeouts = [];
  let animationCompleted = false;

  function debounce(fn, delay, immediate) {
    let timer;
    return function (...args) {
      const callNow = immediate && !timer;
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        if (!immediate) fn.apply(this, args);
      }, delay);
      if (callNow) fn.apply(this, args);
    };
  }

  function waitForElement(selector, callback) {
    const el = document.querySelector(selector);
    if (el) {
      callback([el]);
      return;
    }
    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector);
      if (found) {
        observer.disconnect();
        callback([found]);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function getWrapper() {
    return document.querySelector(`.${NS}__wrapper`);
  }

  function clearAnimationTimeouts() {
    animationTimeouts.forEach((t) => clearTimeout(t));
    animationTimeouts = [];
  }

  function startAnimation() {
    clearAnimationTimeouts();
    const progressFill = document.getElementById(`${NS}-progressFill`);
    if (!progressFill) return;

    const step1 = document.getElementById(`${NS}-step1`);
    const step2 = document.getElementById(`${NS}-step2`);

    progressFill.style.transition = 'none';
    progressFill.style.width = '0%';
    step1?.classList.add(`${NS}--active`);
    step2?.classList.remove(`${NS}--active`);
    progressFill.offsetHeight; // force reflow

    progressFill.style.transition = 'width 5s ease-in-out';
    progressFill.style.width = '100%';

    animationTimeouts.push(
      setTimeout(() => {
        step1?.classList.remove(`${NS}--active`);
        step2?.classList.add(`${NS}--active`);
        animationCompleted = true;
      }, 4000),
    );
  }

  function setCompletedState() {
    const progressFill = document.getElementById(`${NS}-progressFill`);
    if (!progressFill) return;

    const step1 = document.getElementById(`${NS}-step1`);
    const step2 = document.getElementById(`${NS}-step2`);

    progressFill.style.transition = 'none';
    progressFill.style.width = '100%';
    step1?.classList.add(`${NS}--active`);
    step2?.classList.add(`${NS}--active`);
    progressFill.offsetHeight; // force reflow
    progressFill.style.transition = '';
  }

  function insertContent(textCheck, textResult) {
    const footer = document.querySelector(
      '#CartDrawer .drawer__inner .drawer__footer',
    );
    if (!footer || getWrapper()) return;

    footer.insertAdjacentHTML(
      'beforeend',
      `
      <div class="${NS}__wrapper">
        <div class="${NS}__progress-container">
          <div class="${NS}__progress-text">
            <span class="${NS}__progress-text-step ${NS}--active" id="${NS}-step1">
              ${searchIcon} ${textCheck}
            </span>
            <span class="${NS}__progress-text-step" id="${NS}-step2">
              ${tickIcon} ${textResult}
            </span>
          </div>
          <div class="${NS}__progress-wrapper" id="${NS}-progressWrapper">
            <div class="${NS}__progress-line">
              <div class="${NS}__progress-line-fill" id="${NS}-progressFill">
                <div class="${NS}__progress-line-dot"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `,
    );

    animationCompleted ? setCompletedState() : startAnimation();
  }

  function onProductAdded() {
    animationCompleted = false;
    if (getWrapper()) startAnimation();
  }

  function init() {
    const config = document.getElementById('cart-stock-check-config');
    if (!config) return; // disabled via theme settings

    const textCheck = config.dataset.textCheck || 'Bestandsprüfung';
    const textResult = config.dataset.textResult || 'Alle Artikel auf Lager';

    waitForElement('#CartDrawer .drawer__inner .drawer__footer', ([target]) => {
      new MutationObserver(
        debounce(
          () => {
            if (!getWrapper()) insertContent(textCheck, textResult);
          },
          200,
          true,
        ),
      ).observe(target.closest('#CartDrawer'), {
        childList: true,
        subtree: true,
      });

      new PerformanceObserver((entries) => {
        if (
          entries
            .getEntriesByType('resource')
            .some(({ name }) => /\/cart\/add/i.test(name))
        ) {
          onProductAdded();
        }
      }).observe({ entryTypes: ['resource'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
